import analyticsHttp from "@/api/analyticsHttp";

export default {
    getSources: () => analyticsHttp.get('/api/sources'),
    // 202 — отчёт есть, но первый снимок ещё не собран; данных в ответе нет.
    getReport: (source, report, period) =>
        analyticsHttp.get(`/api/reports/${source}/${report}`, {params: {period}}),
}
